import React from 'react';
import Icon from '@/components/ui/AppIcon';
import SEOHeading from '@/components/common/SEOHeading';

interface HealthTest {
  id: number;
  name: string;
  description: string;
  icon: string;
}

interface HealthTestingProtocolProps {
  healthTests: HealthTest[];
}

const HealthTestingProtocol = ({ healthTests }: HealthTestingProtocolProps) => {
  return (
    <section className="mb-16">
      <div className="mb-8 text-center">
        <SEOHeading level={2} className="mb-3">
          Comprehensive Health Testing
        </SEOHeading>
        <p className="text-muted-foreground">
          Every parent dog undergoes rigorous health screening
        </p>
      </div>

      <div className="rounded-xl border border-border bg-card p-8 shadow-warm">
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {healthTests.map((test) => (
            <div key={test.id} className="flex gap-4">
              <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-success/10">
                <Icon
                  name={test.icon as any}
                  size={20}
                  variant="solid"
                  className="text-success"
                />
              </div>
              <div>
                <h3 className="mb-1 font-heading text-base font-semibold text-foreground">
                  {test.name}
                </h3>
                <p className="text-sm leading-relaxed text-muted-foreground">
                  {test.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HealthTestingProtocol;